export type EventMap = {
  roll_completed: { points: number; result: 'hole' | 'ditch' };
  bust: { playerIndex: number; newScore: number };
  skeech: { playerIndex: number };
  turn_completed: { playerIndex: number; points: number; ditches: number };
  match_completed: { isTournament: boolean; tournamentId?: string; playerIndexWon: number };
};

type Handler<T> = (payload: T) => void;

export class EventBus {
  // Use a looser internal typing to avoid TS narrowing issues across mapped keys
  private handlers: { [K in keyof EventMap]?: Handler<any>[] } = {};

  on<K extends keyof EventMap>(name: K, handler: Handler<EventMap[K]>) {
    const arr = (this.handlers[name] ||= []) as Handler<EventMap[K]>[];
    arr.push(handler as any);
    return () => this.off(name, handler);
  }

  off<K extends keyof EventMap>(name: K, handler: Handler<EventMap[K]>) {
    const arr = this.handlers[name] as Handler<EventMap[K]>[] | undefined;
    if (!arr) return;
    const i = arr.indexOf(handler as any);
    if (i >= 0) arr.splice(i, 1);
  }

  emit<K extends keyof EventMap>(name: K, payload: EventMap[K]) {
    const arr = this.handlers[name] as Handler<EventMap[K]>[] | undefined;
    if (!arr) return;
    for (const h of arr) {
      try { (h as any)(payload); } catch {}
    }
  }
}
